export { LogoGrid, type LogoGridProps } from './LogoGrid';
export { logoGridSchema } from './schema';
